/** @format */

import { HomrBannerData, ProductList, SearchVO } from '@plp/data-access/interfaces';

import { Breadcrumb } from '@shared/data-access/interfaces';

/** NOTE:
 *  These mock objects exist to provide empty but type-valid data
 *  to the initial instance of ProductListState. It will immediately be
 *  updated to reflect accurate values once the store is updated at runtime.
 */

export const EmptySearchVO: SearchVO = {
	isFamilyPage: false,
	pageNumber: 0,
	pageSize: 0,
	searchTerm: '',
	searchTypes: [],
	selectedCategory: '',
	selectedFilters: {},
	selectedSort: 0,
	selectedStore: '',
	snbAudience: '',
	storeId: 0,
	totalCount: 0
};

export const EmptyHomrBannerData: HomrBannerData = {
	audience: '',
	backgroundColor: '',
	cononicalName: '',
	content: {
		['Split Ticker']: [
			{
				['Ticker Content']: []
			}
		]
	},
	contentScheduleMeta: null,
	includeInSiteMap: 0,
	metaDescription: null,
	pageNames: [''],
	pageTitle: '',
	promoId: '',
	promoLoggedIn: false,
	requestContext: null,
	staticId: '',
	templateMeta: [],
	templateName: '',
	templateScheduleId: 0,
	templateTag: '',
	tsid: ''
};

export const EmptyProductList: ProductList = {
	categoryDetails: {},
	conversationFacetVOs: [],
	facetVOs: [],
	fuzzyMatch: false,
	homrBannerData: EmptyHomrBannerData,
	isProductListPageValid: false,
	mlBypass: false,
	myStoreZero: false,
	pageNumber: 0,
	pinnedContent: [],
	piqProducts: [],
	priceFilterZero: false,
	productAvailability: null,
	productDetails: {},
	productPromotion: null,
	productVOs: [],
	searchVO: EmptySearchVO,
	selectedSort: 0,
	totalCount: 0,
	viewCount: 0,
	fulfillmentFacets: []
};

export const SAMPLE_SEO_BREADCRUMBS: Breadcrumb[] = [
	{
		categoryId: 202040,
		name: 'Athletic Clothing',
		url: '/c/workout-clothes'
	} as Breadcrumb,
	{
		categoryId: 202041,
		name: "Men's Clothing",
		url: '/c/mens-workout-clothes'
	} as Breadcrumb,
	{
		categoryId: 202048,
		name: "Men's Swimsuits",
		url: '/f/mens-swimsuits'
	} as Breadcrumb,
	{
		categoryId: 10032343,
		name: "Men's Jammers",
		url: '/f/mens-jammer-swimsuits-2625-202048'
	} as Breadcrumb
];
